import NonCachedOffer from './NonCachedOffer';
import { Virtuoso } from 'react-virtuoso';

const NonCachedCardsVirtualized = ({
  deals,
  dateLabel,
  nightsLabel,
}) => {

  return (
    <div style={{ width: '100%' }}>
      <Virtuoso
        useWindowScroll
        totalCount={deals.length}
        itemContent={(index) => {
          const deal = deals[index]
          return (
            <NonCachedOffer
              key={deal.id}
              hotelItem={deal}
              dateLabel={dateLabel}
              nightsLabel={nightsLabel}
              state="default"
              photos={deal.hotelPhotos}
              hotelName={deal.text}
              index={index}
            />
          )
        }}
      />
    </div>
  )
};

export default NonCachedCardsVirtualized;
